/* unplugin-vue-components disabled */import script from "./DetailDrawer.vue?vue&type=script&setup=true&lang=ts"
export * from "./DetailDrawer.vue?vue&type=script&setup=true&lang=ts"

import "./DetailDrawer.vue?vue&type=style&index=0&id=2fcda52c&scoped=true&lang=less"
import "./DetailDrawer.vue?vue&type=style&index=1&id=2fcda52c&lang=less"

import exportComponent from "/data/jenkins/workspace/infra_PayAdminWeb/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2fcda52c"]])

export default __exports__